<template>
  <div class="animated fadeIn" id="sincronizacao-projetos">
    <div class="card card-default">
      <div class="card-header">
        <i class="icon-share"></i> Sincronização de Projetos
      </div>
      <div class="card-body">
        <datatable-panel :per-page="30"
          :url="`${$root.url}/projeto?token=${$root.usuario('access_token')}`"
          :fields="fields"
          :sortField="fields[0]"
          ref="datatable"
          :searchBar="searchBar">
        </datatable-panel>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
  #sincronizacao-projetos {
    .details {
      width: 15px;
    }

    .search-bar {
      & .container-fluid {
        padding-left: 0;

        & button {
          margin-left: 15px;
        }
      }
    }
  }
</style>

<script>
  import Vue from 'vue';

  import DatatablePanel from 'metawesome-datatable';
  import CustomActions from './CustomActions';
  import SearchBar from './SearchBar';
  import Uteis from '@/mixins/utils.js';

  Vue.component('actions-sincronizar', CustomActions);

  export default {
    components: {
      DatatablePanel,
    },

    mixins: [
      Uteis,
    ],

    data() {
      return {
        searchBar: SearchBar,
        fields: [
          { name: 'name', sortField: 'name', title: 'Nome', callback: this.formatarNome },
          { name: 'centro_custo_sap', sortField: 'centro_custo_sap', title: 'Código do Centro de Custo', },
          { name: 'competencia', sortField: 'competencia', title: 'Competência', },
          { name: '__component:actions-sincronizar', title: 'Ações', titleClass: 'details', dataClass: 'details', },
        ],
      };
    },
  }
</script>
